import React from "react";
import FeedbackButton from "./feedback/feedback-button";
import Api from "../api/api";

import PopupDialog from './popups/popup-dialog';
import LoginModal from './login/login-modal';

import AppRoutes from '../routes/routes';
import MarketingNav from './navigation/marketing-nav';
import MarketingFooter from './homepage/marketing-footer';

import '../../css/design-system.scss';

export default class LoggedInTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      popupActive: false
    };
  }

  componentDidMount() {
    Api.scrollCentre();
  }

  render() {
    const { pathname } = this.props.location;
    const key = pathname || "root";

    let loginPopup = this.state.popupActive ? (
      <PopupDialog {...this.props}>
        <LoginModal {...this.props} {...this.state} />
      </PopupDialog>
    ) : (
      ""
    );

    const isChatPage = pathname.startsWith(AppRoutes.chat);

    return (
      <div className="main-container logged-in clearfix">
        {!isChatPage && <MarketingNav {...this.props} userLoggedIn={true} />}
        {React.cloneElement(this.props.children || <div />, { key: key })}
        {!isChatPage && <FeedbackButton {...this.props} />}
        {!isChatPage && <MarketingFooter />}

        {loginPopup}
      </div>
    );
  }
}
